module.exports = require('../lib/admin');
